import { colors } from '../../colors';
var socialIcon = {
  fillColor: colors.coral,
  fillHoverColor: colors.white,
  iconColor: colors.white,
  iconHoverColor: colors.coral,
  iconBorderColor: colors.coral,
  iconBorderHoverColor: colors.white
};
export default socialIcon;